// Käyttäjän asetukset (suunnitelman kohta 12.3): animaatiot ja värinä.
// Puhelimen oma "vähennä liikettä" -asetus noudatetaan aina; tämä asetus
// mahdollistaa saman myös silloin, kun puhelimen asetus ei ole päällä.

import { storage } from "./storage.js";

const DEFAULTS = { reduceMotion: false, vibrate: true };

export function getPrefs() {
  return { ...DEFAULTS, ...storage.get("prefs", {}) };
}

export function setPrefs(prefs) {
  storage.set("prefs", prefs);
  applyPrefs(prefs);
}

export function applyPrefs(prefs = getPrefs()) {
  if (prefs.reduceMotion) document.documentElement.dataset.motion = "reduced";
  else delete document.documentElement.dataset.motion;
}

export function vibrate(pattern) {
  if (getPrefs().vibrate) navigator.vibrate?.(pattern);
}
